import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Plus, Check } from 'lucide-react';
import * as Icons from 'lucide-react';
import { widgetRegistry, WidgetDefinition } from '../../data/widgetRegistry';
interface WidgetCatalogProps {
  open: boolean;
  onClose: () => void;
  onAdd: (id: string) => void;
  activeWidgets: string[];
}
export function WidgetCatalog({
  open,
  onClose,
  onAdd,
  activeWidgets
}: WidgetCatalogProps) {
  const categories: {
    id: WidgetDefinition['category'];
    label: string;
  }[] = [{
    id: 'kpis',
    label: 'KPIs y Resúmenes'
  }, {
    id: 'github',
    label: 'GitHub'
  }, {
    id: 'sprint',
    label: 'Sprint y Progreso'
  }, {
    id: 'team',
    label: 'Equipo y Trabajo'
  }, {
    id: 'activity',
    label: 'Actividad'
  }, {
    id: 'productivity',
    label: 'Productividad'
  }, {
    id: 'calendar',
    label: 'Calendario e Integraciones'
  }];
  return <AnimatePresence data-id="element-3106">
      {open && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-[100] bg-slate-950/80 backdrop-blur-sm" data-id="element-3107" />

          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed top-0 right-0 bottom-0 w-full max-w-[400px] bg-slate-900 border-l border-slate-800 shadow-2xl z-[101] flex flex-col" data-id="element-3108">
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800 bg-slate-900/80 backdrop-blur-md shrink-0" data-id="element-3109">
              <h2 className="text-lg font-bold text-slate-100" data-id="element-3110">
                Catálogo de Widgets
              </h2>
              <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-200 hover:bg-slate-800 rounded-lg transition-colors" title="Cerrar" data-id="element-3111">
                <X size={18} data-id="element-3112" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-8 custom-scrollbar" data-id="element-3113">
              {categories.map(cat => {
            const widgets = widgetRegistry.filter(w => w.category === cat.id);
            if (widgets.length === 0) return null;
            return <div key={cat.id} className="space-y-4" data-id="element-3114">
                    <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider" data-id="element-3115">
                      {cat.label}
                    </h3>
                    <div className="grid grid-cols-1 gap-3" data-id="element-3116">
                      {widgets.map(widget => {
                  const Icon = (Icons as any)[widget.icon] || Icons.Box;
                  const isAdded = activeWidgets.includes(widget.id);
                  return <div key={widget.id} className={`p-4 rounded-xl border transition-all ${isAdded ? 'bg-slate-900/50 border-slate-800/50 opacity-60' : 'bg-slate-800/40 border-slate-700 hover:border-indigo-500/50 hover:bg-slate-800/60'}`} data-id="element-3117">
                            <div className="flex items-start justify-between gap-3" data-id="element-3118">
                              <div className="p-2 bg-slate-900 rounded-lg shrink-0" data-id="element-3119">
                                <Icon size={18} className="text-indigo-400" data-id="element-3120" />
                              </div>
                              <div className="flex-1 min-w-0" data-id="element-3121">
                                <div className="flex items-center gap-2 mb-1" data-id="element-3122">
                                  <h4 className="text-sm font-bold text-slate-200 truncate" data-id="element-3123">
                                    {widget.name}
                                  </h4>
                                  {widget.isNew && <span className="px-1.5 py-0.5 bg-indigo-500/20 text-indigo-400 text-[9px] font-bold rounded-full uppercase tracking-wider" data-id="element-3124">
                                      New
                                    </span>}
                                </div>
                                <p className="text-xs text-slate-400 mb-3 line-clamp-2" data-id="element-3125">
                                  {widget.description}
                                </p>
                                <div className="flex items-center justify-between" data-id="element-3126">
                                  <span className="text-[10px] text-slate-500 font-medium" data-id="element-3127">
                                    {widget.cols === 4 ? 'Ancho completo' : widget.cols === 2 ? 'Medio ancho' : `${widget.cols} columnas`}
                                  </span>
                                  <button onClick={() => onAdd(widget.id)} disabled={isAdded} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors ${isAdded ? 'bg-slate-800 text-slate-500 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500 text-white'}`} data-id="element-3128">
                                    {isAdded ? <>
                                        <Check size={12} data-id="element-3129" /> Agregado
                                      </> : <>
                                        <Plus size={12} data-id="element-3130" /> Agregar
                                      </>}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>;
                })}
                    </div>
                  </div>;
          })}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}